import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnVC: CultureInfo = {
  name: 'en-VC',
  displayName: 'English (St. Vincent & Grenadines)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-VC',
  parent: CultureInfoEn
};
